export default __webpack_public_path__ + "static/media/baking.aca0d659.jpg";